import { render, staticRenderFns } from "./meta_data.vue?vue&type=template&id=2a93d972&"
import script from "./meta_data.vue?vue&type=script&lang=js&"
export * from "./meta_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports